import axios from 'axios'

const service = axios.create({
    timeout: 7000, // 超过7秒提示超时
    // baseUrl: 'http://127.0.0.1:8089'
})

// 请求拦截器
service.interceptors.request.use(
    config => {
        if(localStorage.token) {
            config.headers.Authorization = 'Bearer ' + localStorage.token;
        }
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject(error);
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        // 接收后台参数状态
        const res = response.data;
        console.log("response.data", res);
        if (res.code == 500) {
            // Toast('抱歉，服务器开了点小差, 请稍后再试');
            return Promise.reject(
                new Error(res.message || (res.error &&res.error.message) || '未知错误')
            );
        }
        return res;
        // if(res.code == 200) {
        //     return res;
        // }else {
        //     let message = (res.error && res.error.message) || res.message || res.msg || '未知错误';
        //     Toast(message);
        //     console.log('拦截器打印错误:', res);
        //     // 这里可以设置后台返回状态码是500或者是其他,然后重定向跳转
        //     // if(res.ErrorCode == 500) {
        //     //     router.push('/login')
        //     // }
        //     return Promise.reject(
        //         new Error(res.message || (res.error &&res.error.message) || '未知错误')
        //     );
        // }
    },
    error => {
        // Toast('抱歉，服务器开了点小差, 请稍后再试');
        console.log('服务器错误信息:', error);
        if(error.response) {
            // error.response有错误信息,是接口错误,不是取消请求
            // 获取错误码,弹出提示信息,reject()
            let code = error.response.status;
            if(code == 401) {
                // router.push('/login');
                return Promise.reject(
                    new Error('登录过期,请重新登录')
                );
            }
            // Toast('服务器繁忙, 请稍后再试!  ' + code)
            return Promise.reject(error.message);
        }else {
            // 是取消请求
            // 直接reject
            return Promise.reject(error.message);
        }
    }
)
export default service;


// WEBPACK FOOTER //
// ./src/api/api.js